// import React, {useEffect, useState} from 'react';
import './App.css';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';

import SnowStorm from 'react-snowstorm';
import history from './history';
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import EmailIcon from '@material-ui/icons/Email';

import MyFader from "./MyFader";

const welcomeText = ["Hey there!", "How are you doing?", "Thanks for stopping by.", "Have a good day!"];

function App() {

  // const displayWelcomeText = welcomeText.map((text) =>
  //         <MyFader text={text}/>
  // );


  return (
          <div className="App">
            <SnowStorm
                    className={"pedal"}
                    snowCharacter={'🌸'}
                    vMaxY={1}
                    vMaxX={1}
                    freezeOnBlur={false}
                    snowStick={false}/>
            <header className="App-header">
              {/*{displayWelcomeText}*/}
              <MyFader text={welcomeText}/>

              <ButtonGroup variant="text" color="inherit" aria-label="text primary button group">
                {/* <Button>Home</Button> */}
                <Button onClick={onClick}>Things I care about</Button>
              </ButtonGroup>
              <div className="contact-box">
                <a className="link-color" href="https://github.com/rosemaryng">
                  <GitHubIcon/>
                </a>
                <a className="link-color" href="https://www.linkedin.com/in/rosemary-ng-ls/">
                  <LinkedInIcon/>
                </a>
                <a className="link-color" href="mailto:me@rosemaryng.com">
                  <EmailIcon/>
                </a>
              </div>
            </header>
            <div className='bottom'>
	      <p className='bottom-text'> Disclaimer: The home page was built before LLM was a thing. </p> 
              <text className='bottom-text'> Copyright © 2026 Rosemary Ng </text>
	      
            </div>
          </div>
  );
}


// function SimpleTranslationExample() {
//     const a = Math.random() * (-300);
//     const b = Math.random() * (-300);
//     return (
//         <>
//             <motion.div
//                 className="square"
//                 animate={{x: [a, a + 600], y: [-800, 800]}}
//                 transition={{duration: 20, loop: Infinity, ease: "linear"}}
//             />
//             <motion.div
//                 className="square"
//                 animate={{x: [b, b + 600], y: [-800, 800]}}
//                 transition={{duration: 15, loop: Infinity, ease: "linear"}}
//             />
//         </>
//     );
// }

// function Generator() {
//     let i = 0;
//     for (i = 0; i < 10; i++) {
//         return (SimpleTranslationExample());
//     }
// }

function onClick() {
  history.push("/hub");
}

export default App

